import { render, staticRenderFns } from "./QuranProgram.vue?vue&type=template&id=6e4758cf&"
import script from "./QuranProgram.vue?vue&type=script&lang=js&"
export * from "./QuranProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports